import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PullToRefresh, ListView } from 'antd-mobile';

import './index.less';
import Config from 'config/Config';
import EmptyTips from 'pubBiz/EmptyTips';
import Mod from './indexMod';
import ReactPropTypes from 'prop-types';

import { toJS } from 'mobx';
const CDN_BASE = Config.CDN_BASE || '';

@observer
class MyInfinityScroll extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
    this.stores = new Mod();
  }

  static defaultProps = {
    useGrid: false // 是否采用gird 仅在rowNum大于1时生效
  };

  static propTypes = {
    useGrid: ReactPropTypes.bool
  };

  componentDidMount() {
    console.log('MyInfinityScroll componentDidMount');
    this.init();
  }

  // 初始化
  init = async () => {
    const { apiInfo, othP, rowNum, useGrid } = this.props;
    await this.stores.changeState({
      list: [],
      infinite: false,
      rowNum,
      emptyNum: 0,
      useGrid
    });
    this.stores.getList(apiInfo, othP).then(() => {
      this.props.dataCallback && this.props.dataCallback(this.stores.list);
    });
  };

  refresh = () => {
    const { apiInfo, othP } = this.props;

    this.stores.changeState({ list: [], emptyNum: 0, pageNum: 1 });

    this.stores.getList(apiInfo, othP).then(() => {
      this.props.dataCallback && this.props.dataCallback(this.stores.list);
    });
  };

  /**
   * 加载下一页
   */
  loadNext = (e) => {
    const { end } = this.stores;
    const { apiInfo, othP } = this.props;

    if (end) {
      return;
    }
    this.stores.getList(apiInfo, othP).then(() => {
      this.props.dataCallback && this.props.dataCallback(this.stores.list);
    });
  };

  renderMyCollectList = () => {
    const {
      isPullToRefresh = true,
      styles,
      renderItem = () => <div>666</div>,
      othclassname,
      emptyStyle = {},
      renderFooter = () => null,
      dataCallback
    } = this.props;
    // console.log(111);
    const { list, loading, end, infinite } = this.stores;
    // dataCallback && dataCallback(list);
    // console.log(toJS(list));
    let dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2
    });
    dataSource = dataSource.cloneWithRows({}, list);
    // console.log(list.length, '----->');
    const textObj = {
      activate: end ? '没有更多了' : '松开刷新',
      deactivate: end ? '没有更多了' : '上拉加载更多',
      release: end ? '没有更多了' : `${'正在加载'}...`,
      finish: end ? '没有更多了' : '上拉加载更多'
    };
    if (infinite && this.props.callBack) {
      this.props.callBack();
    }
    console.log(list.length, 'listlistlistlist13213123');
    return (
      <div className="list-wrap" style={styles}>
        {list.length == 0 ? (
          <div style={emptyStyle}>
            <EmptyTips thumb={`${CDN_BASE}/assets/imgs/default/no_order.png`} title="空空如也" />
            {renderFooter()}
          </div>
        ) : (
          <ListView
            dataSource={dataSource}
            // 每次事件循环（每帧）渲染的行数
            pageSize={10}
            renderRow={renderItem}
            className={`list-view ${othclassname}`}
            renderFooter={renderFooter}
            onEndReached={() => {
              console.log('onEndReached');
            }}
            // pullToRefresh={
            //   <PullToRefresh
            //     refreshing={loading}
            //     direction='up'
            ////     onRefresh={(e) => this.loadNext(e)}
            //     indicator={textObj}
            //     onRefresh={() => {}}
            //     damping={0}
            //   />
            // }

            // 首页 查看全部进入 最多显示10条 loadNoNext
            {...(isPullToRefresh && !this.props.loadNoNext
              ? {
                  pullToRefresh: (
                    <PullToRefresh
                      refreshing={loading}
                      direction="up"
                      // onRefresh={(e) => this.loadNext(e)}
                      indicator={textObj}
                      onRefresh={() => {}}
                      damping={0}
                    />
                  )
                }
              : {})}
            onEndReached={(e) => (!this.props.loadNoNext ? this.loadNext(e) : {})}
          />
        )}
      </div>
    );
  };

  render() {
    return <div className="myInfinityScroll-container">{this.renderMyCollectList()}</div>;
  }
}

export default MyInfinityScroll;



// WEBPACK FOOTER //
// ./src/pubBiz/InfiniteScrollByAntd/index.js